// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1fRxi","insightsList":"newBusinessInsightsMenu_insightsList__2kZkm","active":"newBusinessInsightsMenu_active__19GGX"};